import Button from "devextreme-react/button";
import { useContext, useState } from "react";
import { WorkOrderContext } from "../context/WorkOrderContext";
import { apiGenerateWorkOrderReport } from "../api/get-work-order-report";
import { Buffer } from 'buffer';
import { showErrorMessage } from "../../../../utils/messages";
import { LoadPagePanel } from "../../../../components";

export default function PrintButton() {

	const { order } = useContext(WorkOrderContext);

	let [loading, setLoading] = useState(false);

	return (
		<>
			<Button
				text="Print"
				icon="Inscyth-Print"
				onClick={() => {
					setLoading(true);

					apiGenerateWorkOrderReport(order.details.workOrderID)
						.then((result) => {
							if (result.isSuccess) {
								const file = new Blob(
									[Buffer.from(result.data, "base64")],
									{ type: 'application/pdf' });

								const fileURL = URL.createObjectURL(file);
								window.open(fileURL);
							}
							else {
								showErrorMessage(result.errorMessage!);
							}
						})
						.catch((reason) => {
							showErrorMessage(reason);
						})
						.finally(() => { setLoading(false); });
				}}>
			</Button>
			<LoadPagePanel visible={loading} />
		</>
	)
}
